
<Detail :logo-on-click="logoOnClick" show-footer>
    <template v-slot:header>
        <div class="row no-gutters" v-if="isAnalysisLoaded">
            <div class="col col-4">
                <h4>{{ $t("buyer") }}</h4>
                <h2>{{ analysis.name }}</h2>
                <h3>
                    {{ $t("organization_id") | upper }}: {{ analysis.ico }}
                </h3>
            </div>
            <div id="suppliers" class="col col-4">
                <h4>{{ $tc("supplier", 2) }}</h4>
                <h2 class="numeric">
                    {{ formatInteger(analysis.suppliers_count) }}
                </h2>
            </div>
            <div id="period" class="col col-4">
                <h4>{{ $t("period") }}</h4>
                <h2 class="numeric">
                    {{ analysis.start_date | moment("M/YYYY") }} -
                    {{ analysis.end_date | moment("M/YYYY") }}
                </h2>
            </div>
        </div>
    </template>

    <template v-slot:header_small>
        <div class="row no-gutters">
            <div class="col col-8">
                <h2>{{ analysis.name }}</h2>
            </div>
            <div id="period" class="col col-4">
                <h2 class="numeric">
                    {{ analysis.start_date | moment("M/YYYY") }}-{{
                        analysis.end_date | moment("M/YYYY")
                    }}
                </h2>
            </div>
        </div>
    </template>

    <template v-slot:menu>
        <Menu :nav="nav" current="suppliers" />
    </template>

    <template v-slot:content>
        <section id="suppliers_section">
            <h4 class="mt-5 mb-3">{{ $t("overview.suppliers.title") }}</h4>

            <SuppliersTable
                ref="suppliers_table"
                :version="version"
                :hash="hash"
                :init-filter="$store.state.supplierTableFilter"
                :start-page="$store.state.supplierTablePage"
                :per-page="$store.state.supplierTablePerPage"
            />
        </section>
    </template>
</Detail>
